import React from "react";
import { COLORS, COOKIE_CONSENT_NAME } from "~/constants";
import CookieConsent from "react-cookie-consent";
import styles from "./CookieComponent.module.scss";
import { ExternalLink } from "~/components/links/ExternalLink";
import { getBrandPrivacyPolicyUrl } from "~/cores/brandDataCore";

export function CookieComponent(props) {
    const { sharedAppProps } = props;

    const privacyUrl = getBrandPrivacyPolicyUrl(sharedAppProps);
    return (
        <CookieConsent
            enableDeclineButton
            location="bottom"
            flipButtons
            declineButtonText="Deny all"
            buttonText="Accept all"
            cookieName={COOKIE_CONSENT_NAME}
            style={{ background: "#f1f1f1", alignItems: "center" }}
            // buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
            buttonClasses={styles["cookie-buttons"]}
            declineButtonClasses={styles["cookie-buttons"]}
            buttonStyle={{
                color: "black",
                backgroundColor: COLORS.lightGreen,
            }}
            declineButtonStyle={{
                color: "black",
                backgroundColor: "white",
            }}
            expires={365}
        >
            <div style={{ color: "black", fontSize: "13px" }}>
                This website uses cookies to improve your browsing experience and customize content.{" "}
                {privacyUrl && (
                    <>
                        For more information, see our <ExternalLink href={privacyUrl} text={"Privacy Policy"} />.
                    </>
                )}
                <br />
                If you prefer not to be tracked, you can decline, and a cookie will be used to remember your preference.
            </div>
        </CookieConsent>
    );
}

export default CookieComponent;
